import { DateTime } from "luxon"
import { AllowDTO } from "./allow"
import { IKizOsuDTO } from "./KizOsu"

export enum BarcodeType {
    Kiz = 'Kiz',
    KizBox = 'KizBox',
    KizBoxGisMt = 'KizBoxGisMt',
    kizOsu = 'KizOsu',
    Bad = 'Bad'
}

export interface IParsedBarcode {
    barcodeType: BarcodeType
    kizData: IParsedBarcodeKiz
    kizBoxData: IParsedBarcodeKizBox
    kizOsuData: IParsedBarcodeKizOsu
    kizBoxGisMtData: IParsedBarcodeBoxGisMt
}

interface IParsedBarcodeKiz {
    readonly barcode: string
    readonly decodedBarcode: string
    readonly rawBarcode: string
    readonly gtinSGtin: string
    readonly sGtin: string
    readonly gtin: string
    readonly isTrusted?: boolean
}
export interface IKizStatusDTO {
    readonly kizType: BarcodeType
    readonly kizData: {
        idKizGlobal: string,
        state: string,
        idKiz2DocumentItemGlobal: string,
        remain: number
        idParent: string
        isTrusted: boolean
    }
    readonly kizBoxData: {
        idKizBoxGlobal: string,
        state: string,
        idKizBox2DocumentItemGlobal: string,
        remain: number
    }
}

export interface IKizStatusMoveErrorDTO {
    readonly kizType: BarcodeType
    readonly kizData: {
        idKizGlobal: string,
        state: string,
        idError: number,
        idState: number,
    }
    readonly kizBoxData: {
        idKizBoxGlobal: string,
        state: string,
        idError: number,
        idState: number,
    }
    readonly kizBoxGisMtData: {
        idKizBoxGisMtGlobal: string,
        state: string,
        idError: number,
        idState: number,
    }
}

export interface IkizDocumentItemGtinDto {
    readonly idDocumentItemsGlobal: string[],
    readonly kizParsedDto: IParsedBarcode
}

export interface IKizStatusMoveErrorInDTO
{
    readonly barcodes: string[]
    readonly idDocument: string
}

interface IParsedBarcodeKizBox {
    readonly barcode: string
    readonly sscc: string
    readonly gtin?: string
}

interface IParsedBarcodeKizOsu {
    readonly barcode: string
    readonly gtinSGtin: string
    readonly sGtin: string
    readonly gtin: string
    readonly decodedBarcode: string
}
interface IParsedBarcodeBoxGisMt {
    readonly barcode: string
    readonly sscc: string
}

export interface IKizDTO {
    readonly idGlobal: string
    readonly barcode: string
    readonly decodedBarcode: string
    readonly rawBarcode: string
    readonly gtinSGtin: string
    readonly sGtin: string
    readonly gtin: string
    readonly moveState?: string
    readonly kizState?: string
    readonly idError?: number
    readonly isTrusted?: boolean
    readonly isHandScan?: boolean
    readonly barcodeScan?: string
    readonly lotName?: string
    readonly code?: string
    readonly docType?: string
    readonly error?: string
    readonly documentOutId?: string
    readonly remain?: number,
    readonly idParent?: string,
    readonly goodsGroup?: string,
    readonly goodsGroupCode?: number
    readonly state?: string,
    readonly stateMDLP?: string;
}

export interface IKizViewDTO extends IKizDTO {
    readonly numerator: number,
    readonly denominator: number,
    readonly idDocumentItemAdd?: string
}



export interface IKizBoxDTO {
    readonly idGlobal: string
    readonly barcode: string
    readonly sscc: string
    readonly quantity: number
    readonly idError?: number
    readonly lotName?: string
    readonly code?: string
    readonly docType?: string
    readonly error?: string
    readonly documentOutId?: string
    readonly idParent?: string
    readonly isTrusted?: boolean
    readonly kizState?: string;
    readonly stateMDLP?: string;
}

export interface IKizBoxGismtDTO {
    readonly idGlobal: string
    readonly barcode: string
    readonly sscc: string
    readonly quantity: number
    readonly idParent?: string
    readonly isTrusted?: boolean
}

export interface IKizBoxStatusDTO {
    idKizBoxGlobal: string
    state: string
    idKizBox2DocumentItemGlobal: string
    remain: number
}
export interface IKizBoxViewDTO extends IKizBoxDTO {
    readonly idGlobal: string
}

export interface IKiz2DocumentItemGetDTO {
    idDocumentItemGlobal: string,
    kizes: IKizDTO[],
    kizBoxes: IKizBoxDTO[],
    kizOsu?: IKizOsuDTO,
    kizOsuDtos: IKizDTO[]
    kizBoxesGisMt: IKizBoxGismtDTO[]
}

export interface IKiz2DocumentGetDTO {
    idDocumentGlobal: string,
    items: IKiz2DocumentItemGetDTO[]
}

export interface IKiz2InventoryVedAllowDTO extends AllowDTO {
}

export interface IKizConfirmationData {
    idGlobal: string,
    infoSupplier: string,
    infoScanned: string
}

export interface IKizSetTrustedDTO {
    isTrusted: boolean
}

export interface IKizBatchTrustedRequest {
    ids: string[];
    isTrusted: boolean;
}

export interface IKizBox2DocumentItemValidationRequest {
    sscc: string,
    idDocument: string,
    idDocumentItem: string
}

export interface IKizDocBatchDisposalRequest
{
    documentIds: string[],
    schemeMnemocode: string
}

export interface IKizDocBatchDisposalResult
{
    readonly success: boolean,
    readonly totalDocuments: number,
    readonly processedDocuments: number,
    readonly failedDocuments: number,
    readonly processedAt: DateTime,
    readonly message: string
}

export interface IKizDocEditDto
{
    readonly kizDocGlobalIds: string []
    readonly docDate?: DateTime
    readonly docNum: string
    readonly docType: string
    readonly idSubject: string
    readonly idShipper: string
    readonly idReceiver: string
    readonly shipperInn: string
}
